module.exports = __webpack_public_path__ + "img/btn_google_play.41c23493.png";